// @tennis-matches/services/tournament — Min/Max-Teilnehmerzahl (settings.participants)

const PARTICIPANTS_HARD_MIN = 2;
const PARTICIPANTS_HARD_MAX = 48;
const PARTICIPANTS_DEFAULT_MIN = 4;
const PARTICIPANTS_DEFAULT_MAX = 24;

function __toInt(value, fallback) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.trunc(n);
}

/**
 * @returns {{ min: number, max: number }}
 */
export function defaultTournamentParticipants() {
  return { min: PARTICIPANTS_DEFAULT_MIN, max: PARTICIPANTS_DEFAULT_MAX };
}

/**
 * Begrenzt min/max auf den erlaubten Korridor und sorgt für `min <= max`.
 * @param {{ min?: unknown, max?: unknown } | null | undefined} raw
 * @returns {{ min: number, max: number }}
 */
export function normalizeTournamentParticipants(raw) {
  const base = defaultTournamentParticipants();
  if (!raw || typeof raw !== "object") return base;
  let min = __toInt(raw.min, base.min);
  let max = __toInt(raw.max, base.max);
  min = Math.max(PARTICIPANTS_HARD_MIN, Math.min(PARTICIPANTS_HARD_MAX, min));
  max = Math.max(PARTICIPANTS_HARD_MIN, Math.min(PARTICIPANTS_HARD_MAX, max));
  if (min > max) {
    // bei inkonsistenten Werten: max anheben, damit Setup nicht blockiert
    max = min;
  }
  return { min, max };
}

/**
 * @param {{ min?: unknown, max?: unknown } | null | undefined} participants
 * @returns {{ min: number, max: number }}
 */
export function participantsToPersistPayload(participants) {
  return normalizeTournamentParticipants(participants);
}

export const TOURNAMENT_PARTICIPANTS_LIMITS = Object.freeze({
  hardMin: PARTICIPANTS_HARD_MIN,
  hardMax: PARTICIPANTS_HARD_MAX,
  defaultMin: PARTICIPANTS_DEFAULT_MIN,
  defaultMax: PARTICIPANTS_DEFAULT_MAX,
});
